<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link">
            <i>NOTICE: Use contextually-aware output encoding. Only <b>you</b> can prevent payload fires. Or don't, I'm not an XSS cop.</i>
          </a>
        </li>
      </ul>
      <div class="copyright">
        Maintained by <a href="https://mtl-gitlab.mgcorp.co/p_surugiu" target="_blank"><code>Petru Surugiu</code></a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  };
</script>
<style>
</style>
